#import "../fragments/tag-basic.graphql"

mutation EditTag($tag: EditTagInput!) {
    editTag(input: $tag) {
        tag {
            ...TagBasic
        }
    }
}
